import { render, staticRenderFns } from "./TopIndicator.vue?vue&type=template&id=5783d3f0&scoped=true"
import script from "./TopIndicator.vue?vue&type=script&lang=js"
export * from "./TopIndicator.vue?vue&type=script&lang=js"
import style0 from "./TopIndicator.vue?vue&type=style&index=0&id=5783d3f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5783d3f0",
  null
  
)

export default component.exports